import { dialCode, DEFAULT_COUNTRY_CODE } from '@/lib/countries'

// Build an international number (digits only) from a local phone + ISO country
// code — what wa.me / Wasender expect, e.g. "593999999999". Empty when no phone.
export function buildWaNumber(
  phone: string | null | undefined,
  phoneCountryCode: string | null | undefined,
): string {
  const raw = (phone ?? '').replace(/\D/g, '')
  if (!raw) return ''
  const dial = (dialCode(phoneCountryCode ?? DEFAULT_COUNTRY_CODE) ?? '').replace(
    /\D/g,
    '',
  )
  return raw.startsWith(dial) ? raw : `${dial}${raw.replace(/^0+/, '')}`
}

// Pretty-print an international number for display, e.g. "593962975512" →
// "+593 96 297 5512". Ecuador-aware (mobile = 9 digits, grouped 2·3·4); any
// other number falls back to a leading "+" with digits grouped in threes.
export function formatWaNumber(value: string | null | undefined): string {
  const digits = (value ?? '').replace(/\D/g, '')
  if (!digits) return ''
  if (digits.startsWith('593')) {
    const national = digits.slice(3)
    if (national.length === 9) {
      return `+593 ${national.slice(0, 2)} ${national.slice(2, 5)} ${national.slice(5)}`
    }
    return `+593 ${national}`
  }
  return `+${digits.replace(/(\d{3})(?=\d)/g, '$1 ')}`
}
